import React from 'react';

import AppleSignin from 'react-apple-signin-auth';
import AppleSSO from '../../assets/apple_sso.svg';

import { APPLE_CLIENT_ID } from '../../Constants';
import './index.scss';
import { DOMAIN } from '../../Constants/base';

function Apple({ isLogin }) {
  return (
    <AppleSignin
      authOptions={{
        clientId: APPLE_CLIENT_ID,
        redirectURI: `${DOMAIN}/v1/user/v2/login/sso/apple/callback`,
        scope: 'name email',
        usePopup: false,
        nonce: 'nonce',
      }}
      render={(renderProps) => (
        <div className="le-sso-apple" onClick={renderProps.onClick}>
          <img src={AppleSSO} alt="icon" />
          <div className="le-sso-apple-title">{isLogin ? 'Log In' : 'Continue'} With Apple</div>
        </div>
      )}
    />
  );
}

export default Apple;
